import React from "react";

const Section2 = () => {
  return (
    <div className="bg-[#f2efea] px-6 py-16">
      <div className="text-center max-w-4xl mx-auto">
        {/* Main Heading */}
        <h1
          className="text-4xl md:text-5xl font-serif text-gray-800 leading-snug"
          style={{
            fontFamily: "Blacker Pro Display",
          }}
        >
          Our mission is to bring your brand to life, fueling passion and
          creating an authentic online presence.
        </h1>

        {/* Subtext */}
        <p
          className="mt-6 text-lg md:text-xl text-gray-600 leading-relaxed"
          style={{
            fontFamily: "commuterssans-semibold",
          }}
        >
          At Connect Engage Grow, we turn your social media into an
          unforgettable experience. By understanding your brand's unique voice
          and values, we create authentic, impactful content that builds strong
          connections with your audience. We don't just post—we craft moments
          that resonate and make your brand stand out.
        </p>

        {/* Subheading */}
        <p
          className="mt-8 text-base font-semibold tracking-widest text-black-800"
          style={{
            fontFamily: "Blacker Pro Display",
          }}
        >
          Here's how we turn your ideas into reality{" "}
          <span className="text-black text-lg">↓</span>
        </p>
      </div>
    </div>
  );
};

export default Section2;
